// extracted by mini-css-extract-plugin
module.exports = {"MoreInfoIcon":"MoreInfoIcon_MoreInfoIcon__8x58K","Icon":"MoreInfoIcon_Icon__Jc3fP","Tooltip":"MoreInfoIcon_Tooltip__yjQmq"};